/* AB-EXC-19 · in-page "Agotado" block. No fetch on load; 1 Klaviyo POST only on submit. */
if (!customElements.get('ab-agotado')) {
  customElements.define('ab-agotado', class extends HTMLElement {
    connectedCallback() {
      this.bind();
      if (this.unsub || typeof subscribe !== 'function') return;
      // Dawn already fetched the section HTML for the new variant: copy our block from it (0 extra requests).
      this.unsub = subscribe(PUB_SUB_EVENTS.variantChange, (ev) => {
        const d = ev.data || {}, src = d.html && d.html.getElementById(this.id);
        if (!src || !this.isConnected) return;
        this.innerHTML = src.innerHTML;
        this.className = src.className;
        ['variant', 'other'].forEach((k) => { if (src.dataset[k]) this.dataset[k] = src.dataset[k]; else delete this.dataset[k]; });
        this.bind();
      });
    }
    disconnectedCallback() { if (this.unsub) { this.unsub(); this.unsub = null; } }
    bind() {
      const q = (s) => this.querySelector(s);
      this.f = q('form.ab-ag__fm'); this.open = q('[data-ab-open]'); this.ok = q('.ab-ag__ok');
      this.hint = q('[data-ab-hint]'); this.msg = this.f && this.f.querySelector('[role="alert"]');
      if (this.open) this.open.addEventListener('click', () => this.toggle(true));
      q('[data-ab-cancel]')?.addEventListener('click', () => this.toggle(false));
      this.f?.addEventListener('submit', (e) => { e.preventDefault(); this.send(); });
      q('[data-ab-switch]')?.addEventListener('click', (e) => this.switchTo(e.currentTarget.dataset.abSwitch));
    }
    toggle(on) {
      this.f.hidden = !on; this.open.hidden = on; this.hint.hidden = on;
      this.open.setAttribute('aria-expanded', String(on));
      if (on) this.f.email.focus(); else this.open.focus();
    }
    err(t) { this.msg.textContent = t; this.f.email.toggleAttribute('aria-invalid', !!t); }
    async send() {
      const email = this.f.email.value.trim(), key = this.dataset.key, btn = this.f.querySelector('[type="submit"]');
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) return this.err('Revisa tu correo, parece incompleto.');
      if (!key) return this.err('No pudimos guardarlo. Intenta de nuevo.');
      this.err(''); btn.disabled = true; btn.setAttribute('aria-busy', 'true');
      if (this.f.optin && this.f.optin.checked) this.optin(email, key); // CRM opt-in: separate call, never blocks or alters BIS
      try {
        const r = await fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=' + encodeURIComponent(key), {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', revision: '2026-10-15' },
          body: JSON.stringify({ data: { type: 'back-in-stock-subscription',
            attributes: { channels: ['EMAIL'], profile: { data: { type: 'profile', attributes: { email } } } },
            relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + this.dataset.variant } } } } }),
        });
        if (r.status !== 202) throw new Error(String(r.status)); // only 202 means saved; never show "Listo" otherwise
        const [u, dom] = email.split('@');
        this.ok.innerHTML = '<p><b>Listo.</b> Te avisamos a <b></b> cuando vuelva.</p><button type="button" class="link ab-ag__cx">Usar otro correo</button>';
        this.ok.querySelectorAll('b')[1].textContent = u.slice(0, 2) + '•••@' + dom;
        this.ok.querySelector('button').addEventListener('click', () => { this.ok.hidden = true; this.f.hidden = false; this.f.email.focus(); });
        this.f.hidden = true; this.ok.hidden = false; this.ok.tabIndex = -1; this.ok.focus();
      } catch (e) {
        this.err('No pudimos guardarlo. Intenta de nuevo.');
      } finally { btn.disabled = false; btn.removeAttribute('aria-busy'); }
    }
    optin(email, key) {
      fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(key), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', revision: '2026-10-15' },
        body: JSON.stringify({ data: { type: 'subscription',
          attributes: { custom_source: 'PDP agotado – BIS', profile: { data: { type: 'profile', attributes: { email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } },
          relationships: { list: { data: { type: 'list', id: 'URSLcK' } } } } }),
      }).then((r) => { if (!r.ok) console.warn('[ab-agotado] opt-in not saved', r.status); })
        .catch((e) => console.warn('[ab-agotado] opt-in failed', e));
    }
    switchTo(val) {
      // Use Dawn's own picker (1 option: Tamaño) so price, URL, media and this block update the native way.
      const vs = this.closest('product-info')?.querySelector('variant-selects');
      const radio = vs && [...vs.querySelectorAll('input[type="radio"]')].find((r) => r.value === val);
      if (radio) { radio.click(); return; }
      const sel = vs && [...vs.querySelectorAll('select')].find((s) => [...s.options].some((o) => o.value === val));
      if (sel) { sel.value = val; sel.dispatchEvent(new Event('change', { bubbles: true })); return; }
      location.href = location.pathname + '?variant=' + this.dataset.other; // fallback: full load
    }
  });
}
